import { useTranslation } from "react-i18next";
import Particles from "react-tsparticles";
import { formatPID } from "../utils";

function OnboardSuccess({ onSubmitHandler, patientId }) {
  const { t } = useTranslation();
  return (
    <div className="body_content ">
      <div className="inner_body">
        <div className="pattern_block ">
          {/*<Particles id="tsparticles" url="/anim.json" />*/}
          <span className="txt_success_msg">{t("login.SUCCESS.message1")}</span>
        </div>
        <h3 className="subtitle mb-4 text-center">
          {t("login.SUCCESS.message2")}
        </h3>
        <div className="code_block text-center">
          <span className="txt_code">
            {patientId ? formatPID(patientId.toString()) : patientId}
          </span>
        </div>
        <p className="desc text-center">
          {t("login.SUCCESS.message3")} <br />
          {t("login.SUCCESS.message4")} <br />
          {t("login.SUCCESS.message5")}
        </p>
        <div className="btn_block d-flex justify-content-center bottom_button">
          <button
            className="btn btn_primary"
            onClick={() => onSubmitHandler(null)}
          >
            {t("login.SUCCESS.button")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default OnboardSuccess;
